class SmallFormatMenuController {
    constructor($scope, $element, $state, moveFocus, shopPageStateService, shopperService, inspirationService, recipeCategoriesService) {
        this.$element = $element;
        this.moveFocus = moveFocus;
        this.shopPageStateService = shopPageStateService;
        this.shopperService = shopperService;
        this.inspirationService = inspirationService;
        this.recipeCategoriesService = recipeCategoriesService;

        $scope.$on('$stateChangeStart', () => {
            this.closeMenu();
        });

        $scope.$on('$stateChangeSuccess', () => {
            if (!$state.includes(this.menuItems.discover.menuState) && !$state.includes(this.menuItems.recipes.menuState)) {
                this.currentPanel = 'panel1';
            }
        });
    }

    $onInit() {
        this.currentPanel = 'panel1';
        this.menuItems = {
            discover: { name: 'Discover', urlFriendlyName: '', items: [], loading: true, menuState: 'shop.inspiration.**' },
            lists: { name: 'My Lists', urlFriendlyName: '', items: [], loading: true },
            recipes: { name: 'Recipes', urlFriendlyName: '', items: [], loading: true, menuState: 'shop.recipes.**' },
        };
    }

    isMenuOpen() {
        return this.shopPageStateService.smallFormatMenuOpen;
    }

    isCurrentPanel(panel) {
        return this.currentPanel === panel;
    }

    closeMenu() {
        if (this.shopPageStateService.smallFormatMenuOpen) {
            this.shopPageStateService.smallFormatMenuOpen = false;
        }
    }

    openPanel(panel) {
        this.currentPanel = panel;
        this.moveFocus(`.smallMenu-${panel} nav a:first-child`)
            .then(() => this.$element.find('#smallMenu').scrollTop(0).scrollLeft(0));
    }

    openInspirationMenu($event) {
        $event.preventDefault();

        this.openPanel('panel2');
        this.subMenus = { level1: this.menuItems.discover };

        this.inspirationService.getNavigationItems()
            .then(items => (this.menuItems.discover.items = this.mapInspirationNavigation(items)))
            .finally(() => (this.menuItems.discover.loading = false));
    }

    openRecipesMenu($event) {
        $event.preventDefault();

        this.openPanel('panel2');
        this.subMenus = { level1: this.menuItems.recipes };

        this.recipeCategoriesService.getAll()
            .then((items) => {
                this.menuItems.recipes.items = this.mapRecipesNavigation(items);
                if (!this.shopperService.IsGuest) {
                    this.menuItems.recipes.items.unshift({ name: 'My Favourite Recipes', items: [], sref: 'shop.recipes.savedList' });
                }
            })
            .finally(() => (this.menuItems.recipes.loading = false));
    }

    mapInspirationNavigation(items, parent) {
        return items.map(i => ({
            name: i.Name,
            items: this.mapInspirationNavigation(i.Items || [], i),
            sref: `shop.inspiration.${parent ? 'parent.child' : 'parent'}(${parent ? `{ parent: '${parent.UrlPart}', child: '${i.UrlPart}' }` : `{ parent: '${i.UrlPart}' }`})`,
        }));
    }

    mapRecipesNavigation(items, parent) {
        return items.map(i => ({
            name: i.Name,
            items: this.mapRecipesNavigation(i.ChildCategories || [], i),
            sref: `shop.recipes.${parent ? 'category.subCategory' : 'category'}(${parent ? `{ category: '${parent.UrlFriendlyName}', subCategory: '${i.UrlFriendlyName}' }` : `{ category: '${i.UrlFriendlyName}' }`})`,
        }));
    }

    onLevel2Select($event, item) {
        if (item.items && item.items.length > 0) {
            this.openPanel('panel3');
            this.subMenus = { level1: this.subMenus.level1, level2: item };
            $event.preventDefault();
        }
    }
}

const smallFormatMenuComponentDefinition = {
    controller: ['$scope', '$element', '$state', 'MoveFocus', 'ShopPageStateService', 'ShopperService', 'InspirationService', 'RecipeCategoriesService', SmallFormatMenuController],
    template: require('./small-format-menu.component.html').trim(),
};

module.exports = {
    SmallFormatMenuController,
    smallFormatMenuComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/smallformatmenu/small-format-menu.component.js